'use client'

import { Box, Text, VStack } from '@chakra-ui/react'
import { IRecipe } from '@/_types'
import { useCustomLocale } from '@/_hooks/useCustomLocale'
import { useTranslations } from 'next-intl'

export default function RecipeSteps({ data }: { data: IRecipe }) {
  const t = useTranslations()
  const currentLocale = useCustomLocale()
  const steps = data?.steps?.filter((item) => item?.[currentLocale]) || []

  if (!steps.length) return null

  const title =
    steps.length >= 2
      ? `${t('steps_title')} ${data?.title?.[currentLocale]?.toLowerCase() || ''}`
      : `${t('how_to_cook')} ${data?.title?.[currentLocale]?.toLowerCase() || ''}`

  return (
    <VStack align='stretch' gap={4}>
      <Text fontSize='20px' fontWeight={700}>
        {title}
      </Text>
      {steps.map((item, index) => (
        <Box key={index}>
          <Text fontWeight={600} mb={1}>
            {t('step')} {index + 1}.
          </Text>
          <Text fontSize='14px' color='text.muted' lineHeight='20px'>
            {item?.[currentLocale]}
          </Text>
        </Box>
      ))}
    </VStack>
  )
}
